import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { menuBoxStyle } from './styles';
import { useMenuPosition } from './useMenuPosition';
import { useMenuEvents } from './useMenuEvents';
import EditMode from './EditMode';
import MenuItems from './MenuItems';

const HistoryItemMenu = ({
  anchorEl,
  onClose,
  handleEditHistory,
  handleDeleteClick,
  projects,
  handleAddHistoryToProject,
  historyId,
  currentTitle = '',
  setIsAnyHistoryEditing
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [newTitle, setNewTitle] = useState(currentTitle);
  const menuRootRef = useRef(null);
  const firstMenuRef = useRef(null);
  const subMenuRef = useRef(null);
  const inputRef = useRef(null);

  // 분리된 훅들 사용
  const { menuPos, subMenuPos } = useMenuPosition(anchorEl, isMobile, subMenuOpen, firstMenuRef);
  const { hoverIdx, setHoverIdx } = useMenuEvents(open, () => {
    setOpen(false);
    setSubMenuOpen(false);
    setIsEditing(false);
    onClose && onClose();
  }, isEditing, inputRef, menuRootRef);

  // 메뉴 열기/닫기
  useEffect(() => {
    if (anchorEl) {
      setOpen(true);
    } else {
      setOpen(false);
      setSubMenuOpen(false);
      setIsEditing(false);
    }
  }, [anchorEl]);

  // 인풋 자동 포커스
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  // 편집 상태 전달
  useEffect(() => {
    if (setIsAnyHistoryEditing) setIsAnyHistoryEditing(isEditing);
  }, [isEditing, setIsAnyHistoryEditing]);

  if (!open) return null;
  if (!anchorEl) return null;

  return ReactDOM.createPortal(
    <div
      ref={menuRootRef}
      data-menu-type="history"
      style={{ 
        ...menuBoxStyle, 
        left: menuPos.left, 
        top: menuPos.top, 
        position: 'absolute', 
        margin: 0, 
        padding: 0 
      }}
    >
      {isEditing ? (
        <EditMode
          inputRef={inputRef}
          newTitle={newTitle}
          setNewTitle={setNewTitle}
          handleEditHistory={handleEditHistory}
          historyId={historyId}
          setIsEditing={setIsEditing}
          setOpen={setOpen}
          onClose={onClose}
          currentTitle={currentTitle}
        />
      ) : (
        <MenuItems
          firstMenuRef={firstMenuRef}
          subMenuRef={subMenuRef}
          hoverIdx={hoverIdx}
          setHoverIdx={setHoverIdx}
          subMenuOpen={subMenuOpen}
          setSubMenuOpen={setSubMenuOpen}
          subMenuPos={subMenuPos}
          menuPos={menuPos}
          projects={projects}
          handleAddHistoryToProject={handleAddHistoryToProject}
          historyId={historyId}
          setOpen={setOpen}
          onClose={onClose}
          setIsEditing={setIsEditing}
          setNewTitle={setNewTitle}
          currentTitle={currentTitle}
          handleDeleteClick={handleDeleteClick}
        />
      )}
    </div>,
    document.body
  );
};

export default HistoryItemMenu; 